import type { RuntimeConfig } from './types';

export const runtimeKeys = {
  ASSET_SERVER: 'ASSET_SERVER',
  PROVIDER_DIRECTORY_SDK: 'PROVIDER_DIRECTORY_SDK',
  GRID_LICENSE: 'GRID_LICENSE',
  PDF_LICENSE: 'PDF_LICENSE',
  USE_API_PROXY_ROUTES: 'USE_API_PROXY_ROUTES',
  UI_LOG_LEVEL: 'UI_LOG_LEVEL',
  RUM_DEBUG: 'RUM_DEBUG',
} as const;

export type RuntimeKey = (typeof runtimeKeys)[keyof typeof runtimeKeys];

type BuildConfigFields = {
  GRID_LICENSE_KEY?: string;
  LICENSE_STORAGE_KEY?: string;
};

type KeyDescriptor = {
  overrideJsonKey: string;
  runtimeField?: keyof RuntimeConfig;
  buildField?: keyof BuildConfigFields;
  default: string;
  kind?: 'flag';
};

/** Keys readable via `getRuntime().flag()` (inherit when unset). */
export const FLAG_RUNTIME_KEYS = [runtimeKeys.USE_API_PROXY_ROUTES, runtimeKeys.RUM_DEBUG] as const;
export type FlagRuntimeKey = (typeof FLAG_RUNTIME_KEYS)[number];

export const KEY_DESCRIPTORS: Record<RuntimeKey, KeyDescriptor> = {
  [runtimeKeys.ASSET_SERVER]: {
    overrideJsonKey: 'assetServer',
    runtimeField: 'ASSET_SERVER',
    default: '',
  },
  [runtimeKeys.PROVIDER_DIRECTORY_SDK]: {
    overrideJsonKey: 'providerDirectorySdk',
    runtimeField: 'PROVIDER_DIRECTORY_SDK',
    default: '1.5.9',
  },
  [runtimeKeys.GRID_LICENSE]: {
    overrideJsonKey: 'gridLicenseKey',
    runtimeField: 'GRID_LICENSE_KEY',
    buildField: 'GRID_LICENSE_KEY',
    default: '',
  },
  [runtimeKeys.PDF_LICENSE]: {
    overrideJsonKey: 'licenseStorageKey',
    runtimeField: 'LICENSE_STORAGE_KEY',
    buildField: 'LICENSE_STORAGE_KEY',
    default: '',
  },
  [runtimeKeys.USE_API_PROXY_ROUTES]: {
    overrideJsonKey: 'useApiProxyRoutes',
    runtimeField: 'USE_API_PROXY_ROUTES',
    default: '',
    kind: 'flag',
  },
  [runtimeKeys.UI_LOG_LEVEL]: {
    overrideJsonKey: 'logLevel',
    runtimeField: 'UI_LOG_LEVEL',
    default: '',
  },
  [runtimeKeys.RUM_DEBUG]: {
    overrideJsonKey: 'rumDebug',
    default: '',
    kind: 'flag',
  },
};
